/**
 * 구독 결제 유형 — 서버가 결제 건마다 내려주는 priceType 값.
 *  - 회원 목록 GET /admin/users: users[].subscriptionInfo.priceType · paidAmount, 필터 파라미터 priceType
 *  - 매출분석 GET /admin/revenue/monthly: subscriptionDetail.{grade}.priceTypes.{REGULAR|HALF|PROMO_100} = { count, amount }
 * 서버 필드 이름이 바뀌면 이 파일과 매출분석의 SubscriptionPriceTypeSummary 만 맞추면 된다.
 */
export const PRICE_TYPES = [
  { key: "REGULAR", label: "정상가" },
  { key: "HALF", label: "50% 할인" },
  { key: "PROMO_100", label: "100원 혜택" },
];

const LABEL_BY_KEY = Object.fromEntries(PRICE_TYPES.map((t) => [t.key, t.label]));

// 대소문자·밑줄 표기 차이(regular, promo100, PROMO_100 …)를 REGULAR/HALF/PROMO_100 으로 맞춘다
export function normalizePriceType(value) {
  if (value == null || value === "") return null;
  const compact = String(value).toUpperCase().replace(/_/g, "");
  if (compact === "REGULAR") return "REGULAR";
  if (compact === "HALF") return "HALF";
  if (compact === "PROMO100") return "PROMO_100";
  return null;
}

export function priceTypeLabel(value) {
  const key = normalizePriceType(value);
  if (key) return LABEL_BY_KEY[key];
  return value ? String(value) : null;
}

// 결제 유형 키 → CSS 수식어 (price-type-badge--regular 등)
export function priceTypeModifier(value) {
  const key = normalizePriceType(value);
  return key ? key.toLowerCase().replace("_", "-") : "unknown";
}
